import { createEmptySignatureForm, INITIAL_FORM_ERRORS } from "./constants";
import { isInstitutionalSignature } from "./helpers";

export const validateEventSignatureForm = (
	form = createEmptySignatureForm()
) => {
	const requiresSingleCampus = isInstitutionalSignature(
		form.signatureTypeCode
	);
	const errors = {
		...INITIAL_FORM_ERRORS,
		signatureTypeCode: !form.signatureTypeCode,
		campusIds: requiresSingleCampus
			? form.campusIds.length !== 1
			: form.campusIds.length === 0,
		displayName: !form.displayName.trim(),
		signatureFile:
			!form.signatureFile?.name &&
			!form.signatureFile?.base64,
		validFrom: form.validFrom === -1,
		validTo:
			!form.isIndefiniteValidity &&
			(form.validTo === -1 || form.validTo < form.validFrom),
	};

	if (
		(form.signatureFile?.name || form.signatureFile?.base64) &&
		!/\.png$/i.test(form.signatureFile?.name || "")
	) {
		errors.signatureFile = true;
	}

	return {
		errors,
		isValid: !Object.values(errors).some(Boolean),
	};
};
